// src/components/Checkout/CartItem.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import useProductData from "@/hooks/useProductData";
import styles from "./Checkout.module.scss";

type OrderType = "exchpart" | "sellpart";

interface CartItemProps {
  item: {
    goid: string;
    quantity: number;
    table: string;
    typeorder: OrderType;
  };
}

export const CartItem: React.FC<CartItemProps> = ({ item }) => {
  const { t } = useTranslation("common");
  const { product, loading } = useProductData(item.goid, item.table);

  if (loading) {
    return (
      <li className={styles.cartItem}>
        <p>{t("cart.loading")}</p>
      </li>
    );
  }

  if (!product) {
    return (
      <li className={styles.cartItem}>
        <p>{t("cart.productNotFound")}</p>
      </li>
    );
  }

  const price =
    item.typeorder === "sellpart" ? product.pricevat : product.priceexchvat;
  const validPrice = price ?? 0;
  const totalPrice = validPrice * item.quantity;

  return (
    <li className={styles.cartItem}>
      <div className={styles.imgBlock}>
        <img
          src={product.imageUrl || "/images/Shop/template.webp"}
          alt={product.name}
          className={styles.cartItemImage}
        />
        <p className={styles.quantity}>{item.quantity}</p>
      </div>
      <div className={styles.infoBlock}>
        <h4>{product.name}</h4>
        <p className={styles.typeorder}>
          {t(`cart.orderType.${item.typeorder}`)}
        </p>
      </div>
      <p className={styles.price}>€{totalPrice.toFixed(2)}</p>
    </li>
  );
};
